module.exports = __webpack_public_path__ + "static/media/arrow-down-black.2fa43ce7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/arrow-down-black.svg
// module id = 1125
// module chunks = 0